import React from 'react';

const Impressum = () => {
  return (
    <div className="myn-legal">
      <div className="myn-card">
        <h1 className="myn-h2">Impressum</h1>

        <div className="myn-prose">
          <h2>Angaben gemäß § 5 TMG</h2>
          <p>
            <strong>Firma:</strong> EDEL Investment GmbH<br />
            Marienburger Str. 2D<br />
            40789 Monheim am Rhein<br />
            Deutschland
          </p>

          <h2>Sitz</h2>
          <p>
            EDEL Investment GmbH<br />
            Marienburger Str. 2D<br />
            40789 Monheim am Rhein<br />
            Deutschland
          </p>

          <h2>Geschäftsführer</h2>
          <p>Muhsin Bayar</p>

          <h2>Kontakt</h2>
          <p>
            Telefon: [Telefonnummer]<br />
            E-Mail: <a href="mailto:edelabcmail@gmail.com">edelabcmail@gmail.com</a>
          </p>

          <h2>Umsatzsteuer-ID</h2>
          <p>USt-IdNr.: HRB 86011</p>
          <p>Amtsgericht Düsseldorf</p>

          <h2>Wirtschafts-Identifikationsnummer</h2>
          <p>HRB 86011</p>

          <h2>Haftungsausschluss</h2>
          <p>
            Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die
            Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch
            keine Gewähr übernehmen.
          </p>

          <h2>Verlinkungen</h2>
          <p>
            Unsere Website kann Links zu externen Webseiten Dritter enthalten. Für die
            Inhalte dieser Seiten sind wir nicht verantwortlich.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
